
// Interface for NoteOption details
export interface INoteOption {
    note?: string;
}

// Type definition to allow for INoteOption or true
export type TypeNoteOption = INoteOption | true;

export enum EnumSideOptions {
    Left = "l",
    Right = "r"
}

export enum EnumGender {
    Male = "male",
    Female = "female",
    Other = "other"
}
